export default (name, allowMultipleFiles = false, existingPreviewUrl = null, existingPath = null, errorMessage = 'The file could not be uploaded. Please check the file and try again.', removeProperty = null) => ({
    name,
    allowMultipleFiles,
    errorMessage,
    removeProperty,
    isDroppingFile: false,
    isUploading: false,
    progress: 0,
    uploadError: null,
    existingPreviewUrl,
    existingPath,
    handleFileSelect(event) {
        if (event.target.files.length) {
            this.uploadFiles(event.target.files)
        }
    },
    handleFileDrop(event) {
        if (event.dataTransfer.files.length > 0) {
            this.uploadFiles(event.dataTransfer.files)
        }
    },
    handleSuccessfulUpload(success) {
        this.isUploading = false;
        this.progress = 0;
        this.uploadError = null;
    },
    handleError(error) {
        this.isUploading = false;
        this.progress = 0;
        this.uploadError = this.errorMessage;

        console.error('Error uploading file', error);
    },
    handleUploadProgress(event) {
        this.progress = event.detail.progress;
    },
    uploadFiles(files) {
        this.isUploading = true;
        this.uploadError = null;

        if (this.allowMultipleFiles) {
            this.$wire.uploadMultiple(this.name, files, (success) => this.handleSuccessfulUpload(success), (error) => this.handleError(error), (event) => this.handleUploadProgress(event));
        } else {
            this.$wire.upload(this.name, files[0], (success) => this.handleSuccessfulUpload(success), (error) => this.handleError(error), (event) => this.handleUploadProgress(event));
        }
    },
    removeFile() {
        this.$wire.set(this.name, null);

        if (this.removeProperty) {
            this.$wire.set(this.removeProperty, true);
        }

        this.existingPreviewUrl = null;
        this.existingPath = null;
        this.uploadError = null;
    },
    removeUpload(filename) {
        this.$wire.removeUpload(this.name, filename);
    },
    dropzone: {
        ['x-on:drop']() {
            this.isDroppingFile = false;
        },
        ['x-on:drop.prevent'](event) {
            this.handleFileDrop(event);
        },
        ['x-on:dragover.prevent']() {
            this.isDroppingFile = true;
        },
        ['x-on:dragleave.prevent']() {
            this.isDroppingFile = false;
        },
        ['x-bind:class']() {
            return {
                'border-brand-500 bg-gray-5': this.isDroppingFile,
            };
        },
    },
    previewImage: {
        ['x-bind:src']() {
            return this.existingPreviewUrl;
        }
    },
    uploadInput: {
        ['x-on:change'](event) {
            this.handleFileSelect(event);
        }
    },

    /*
     * The width used to live in a `:style` template literal, which Alpine's CSP
     * build rejects. Bound attribute objects live in JS, where a template
     * literal is ordinary code — and the bar picks up its ARIA here too.
     */
    progressBar: {
        ['role']: 'progressbar',
        ['aria-valuemin']: '0',
        ['aria-valuemax']: '100',
        [':aria-valuenow']() {
            return this.progress;
        },
        [':style']() {
            return `width: ${this.progress}%;`;
        },
    },
});